import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { ProsemirrorBasicConfig } from '@core/prosemirror-legacy/webapp';
import type { LayoutListRowComponent } from '@core/views-util';
import type { AskTemplateViewItem } from '@tellent-ask-hr/core-types';

import { ChatFormItemComponent } from '../../chat-form-item/chat-form-item.component';
import { ChatUserTemplatesDataSourceService } from '../chat-user-templates-data-source.service';

@Component({
  selector: 'asks-form-list-item',
  imports: [ChatFormItemComponent],
  template: '<ask-chat-form-item [template]="record"/>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(click)': 'onClick()',
  },
})
export class UserFormListItemComponent implements LayoutListRowComponent<AskTemplateViewItem> {
  private readonly userTemplatesDataSourceService = inject(ChatUserTemplatesDataSourceService);
  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  @Input() public record: LayoutListRowComponent<AskTemplateViewItem>['record'];
  @Input()
  public fieldsVisibilityMap: LayoutListRowComponent<AskTemplateViewItem>['fieldsVisibilityMap'];

  protected onClick(): void {
    this.userTemplatesDataSourceService.openNewTicket(this.record.id);
  }
}
